export default "__VITE_ASSET__Ckxv309k__"